import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { CloseIcon } from "../Icons";

interface ModalToolbarProps {
  canGoBack: boolean;
  showClose: boolean;
  onBack: () => void;
  onClose: () => void;
  closeIcon?: React.ReactNode;
}

export const ModalToolbar = ({
  canGoBack,
  showClose,
  onBack,
  onClose,
  closeIcon,
}: ModalToolbarProps) => (
  <div className="w-full flex justify-between">
    {canGoBack ? (
      <ArrowBackIcon
        onClick={onBack}
        className="text-light-black cursor-pointer"
      />
    ) : (
      <span />
    )}
    {showClose && (
      closeIcon ? (
        <div onClick={onClose} className="cursor-pointer">
          {closeIcon}
        </div>
      ) : (
        <CloseIcon
          onClick={onClose}
          className="text-light-black cursor-pointer"
        />
      )
    )}
  </div>
);
